import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { ShoppingCart, Target, Gavel, Brain, ArrowRight, Package, BarChart3 } from "lucide-react";

export function Solutions() {
  const solutions = [
    {
      icon: ShoppingCart,
      title: "ProcPay",
      description: "Unified procure-to-pay automation platform integrating contracts, sourcing, schemes, and settlements with real-time AI control.",
      color: "bg-primary"
    },
    {
      icon: Package,
      title: "ProLiMa",
      subtitle: "(Product Lifecycle Management)",
      description: "End-to-end product lifecycle management—from onboarding and enrichment to listing, revision, and retirement—with workflow automation.",
      color: "bg-secondary"
    },
    {
      icon: Brain,
      title: "NexAI",
      description: "Central AI engine powering predictive analytics, smart alerts, and optimization across procurement, schemes, and inventory.",
      color: "bg-yellow-500"
    },
    {
      icon: BarChart3,
      title: "Demand Forecasting",
      description: "AI-driven demand planning tool using trends, promotions, and pricing inputs to deliver accurate, adaptive forecasts by SKU and region.",
      color: "bg-accent"
    }
  ];

  return (
    <section className="py-16 lg:py-24" style={{ backgroundColor: '#F6FBEA' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 text-3xl lg:text-4xl text-black font-bold">Solutions Snapshot</h2>
          <p className="text-lg text-muted-foreground">
            Four powerful modules working together to transform your procurement and scheme management operations.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {solutions.map((solution, index) => (
            <Card 
              key={index} 
              className="group transition-all hover:shadow-lg hover:-translate-y-1 bg-white flex flex-col h-full"
            >
              <CardHeader>
                <div className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg ${solution.color}`}>
                  <solution.icon className="h-6 w-6 text-white" />
                </div>
                <CardTitle className="font-bold">
                  {solution.subtitle ? (
                    <div>
                      <div>{solution.title}</div>
                      <div className="text-sm font-normal text-muted-foreground mt-1">{solution.subtitle}</div>
                    </div>
                  ) : (
                    solution.title
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col flex-1">
                <p className="mb-4 text-sm text-muted-foreground flex-1">
                  {solution.description}
                </p>
                <div className="mt-auto">
                  <Button 
                    variant="ghost" 
                    className="group/btn p-0 h-auto text-primary hover:text-white hover:bg-transparent transition-colors"
                    style={{
                      '--hover-bg': '#4B3425'
                    } as React.CSSProperties}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#4B3425';
                      e.currentTarget.style.padding = '8px 12px';
                      e.currentTarget.style.borderRadius = '6px';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.padding = '0';
                    }}
                  >
                    Learn More
                    <ArrowRight className="ml-1 h-4 w-4 text-secondary transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}